/*
	VIEWS: Radio Shows
	
	- Radio shows and Radio episodes are the exact same page show different data.
	So we have two views, one for the show wrapper, and one for the episode itself.

	================================

	If you just want the Show:
		This expects the show as a model. The view will then call out to get episodes 
		so it can choose the most recent episode to display.
	
	APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-radio',{
		model:data
	}));
	
	================================
	
	If you have an Episode to display:
		You need both the show model and the episode model. 
		Because episode get wrapped in show details, pass the show as the main content and the episode as secondary
		
	APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-radio',{
		 model : showData	
		,attributes:{ episode:episodeData }
	}));
 */


/************************************************************************************
	RADIO - Episode 
	(used from inside 'show-radio'. Probably not called directly)
 ************************************************************************************/ 
Backbone.Radio.channel('views').reply('show-radio-episode',function(options){
	var episodeView = Mn.View.extend({
         template:"#tmpl-show-radio-episode"
        ,templateContext:function(){
	        var mostRecent;
            if(options.collection){
		    	mostRecent = _.last(options.collection.models)
	        }else{
		        mostRecent = options.model
	        }
	        return {
                 'title':mostRecent.attributes.title
                ,'desc_long':mostRecent.attributes.desc_long
                ,'airdate':moment(mostRecent.attributes.assets[0].airdate,"YYYY-MM-DD").format('dddd, MMMM Do')
                ,'ingestType':options.attributes.program.ingestType
                ,'isLocal': options.attributes.isLocal
                ,"slug": options.attributes.program.slug
            };
        }
        ,onAttach:function(){
	        var episode = (options.collection)? _.last(options.collection.models) : options.model;
	        Backbone.Radio.channel('media').request('setupMedia',{
	             asset:episode.attributes.assets[0]
	            ,target:"player"
	            ,playlist:(episode.attributes.assets[0].type==="segment")?episode.attributes.assets:""
	            ,program:(options.attributes && options.attributes.program)?options.attributes.program:""
	        })
            
	        if(episode.attributes.assets[0].playlist){
	            var html = Backbone.Radio.channel('views').request('radio-playlist',episode.attributes.assets[0].playlist);
				if(html){ $('#playlistContainer').replaceWith(html) }
			}
			if(episode.attributes.assets[0].type==="segment"){
				var segHtml = Backbone.Radio.channel('views').request('radio-segments',episode.attributes.assets);
				if(segHtml){ $('#playlistContainer').replaceWith(segHtml) }
			}
			
			
			/* 
				Social
				- We want the social icons in the program view, but we might not know what episode to show
				at that point, so append it here.
			 */
			var htm = "";
			htm += '<a class="pr1" target="_blank" alt="Follow us on Facebook" href="https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(window.location.href)+'&caption=mediaplayer.whro.org&title='+encodeURIComponent(options.attributes.program.title+": "+episode.attributes.title)+'"><img style="width:32px" src="/assets/imgs/social/icon_fb_b.png" /></a>';			
			htm += '<a class="pr1" target="_blank" alt="Tweet Us" href="https://twitter.com/intent/tweet?via=WHRO&url='+encodeURIComponent(window.location.href)+'&text='+encodeURIComponent(options.attributes.program.title+": "+episode.attributes.title)+'"><img style="width:32px" src="/assets/imgs/social/icon_twitter_b.png" /></a>';
			
			$('.radioSocial').last().prepend(htm);
			
			/* 
	           Google Ads 
	         */
            Backbone.Radio.channel('ads').trigger('show','radio')
	        
        }
    });
	   
	return new (episodeView)();
});





/************************************************************************************
	RADIO - Live Episode 
	(used from inside 'show-radio'. Probably not called directly)
 ************************************************************************************/ 
Backbone.Radio.channel('views').reply('show-live-radio-episode',function(options){
	
	var episodeView = Mn.View.extend({
         model:options.model
        ,template:"#tmpl-show-radio-episode"
        ,templateContext:function(){
	        return {
                 playlist	: ""
                ,title		: "Live Now"
                ,desc_long	: ""	//this is the program desc, which we don't want to show a 2nd time on the page
                ,isLocal	: options.attributes.isLocal
            };
        }
        ,onAttach:function(){
	        var that = this;
            /* Live Station */
            $.when( Backbone.Radio.channel('entities').request('station',+that.model.attributes.stationid) ).done(function(data){ 
	            /* 
	                Setup the audio player 
	            */
				var options = {
					"controls": true,
					"audioOnlyMode": true,
					"preload": "metadata",
				}
				
				var player = videojs('player', options, () => {
					player.log('Videojs player ready')
					player.playlist([{
						"sources":[{
							"src": data.attributes.files.public[0].url
							,'type':'audio/mp3'
						}]
					}])
				})
	
				var imaOptions = {
					adTagUrl: "http://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/3405737/Audio_General&ciu_szs&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=[referrer_url]&correlator=[timestamp]"
				};
				player.ima(imaOptions);
	
				player.on("adsready", function(response) {
					player.ima.addEventListener("complete", function(){
						player.play()
						});
				})

				player.on('ready', function() {
					gtag('event', 'ready') 
				})
				player.on('play', function() {
					gtag('event', 'play') 
				})
				player.on('pause', function() {
					gtag('event', 'pause') 
				})
				player.on('ended', function() {
					gtag('event', 'ended') 
				})
				player.on('seeked', function() {
					gtag('event', 'seeked') 
				})
				player.on('waiting', function() {
					gtag('event', 'buffer') 
				})
				
				var htm;
				htm += 	"<style>" 
				htm += 		".player-dimensions { width: 100%; height: 40px}"
				htm += 		".vjs-control-bar { height: 40px !important; padding-top: 5px !important; background-color: #004f71 !important;}"
				htm += 		".videoAdUiAttribution { margin-bottom: 1.4rem !important; }"
				htm += 	"</style>"
				$("#tmpl-stations-show").append(htm)
	        })
            
            
            
            
            /* Live Playlist */
            if(this.model.attributes.ingestType==="crawl" 
            	&& that.model.attributes.playlistName){ //only crawled programs have live playlists
	            //get initial live playlist
				$.when( Backbone.Radio.channel('entities').request('show_liveplaylist',that.model.attributes.id,that.model.attributes.stationid) ).done(function(data){
					var html = Backbone.Radio.channel('views').request('radio-playlist',data);
					if(html){ $('#playlistContainer').replaceWith(html) }
				})
	            
				setInterval(function(){ //yeah, we're repeating the above code, but it's only 4 lines
					$.when( Backbone.Radio.channel('entities').request('show_liveplaylist',that.model.attributes.id,that.model.attributes.stationid) ).done(function(data){
						var html = Backbone.Radio.channel('views').request('radio-playlist',data);
						if(html){ $('#playlistContainer').replaceWith(html) }		
					})
				},60000)
			}
			
			/* 
				Social
			 */
			var htm = "";
			htm += '<a class="pr1" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(window.location.href)+'&caption=mediaplayer.whro.org&title='+encodeURIComponent(this.model.attributes.title)+'"><img style="width:32px" src="/assets/imgs/social/icon_fb_b.png" /></a>';			
			htm += '<a class="pr1" target="_blank" href="https://twitter.com/intent/tweet?via=WHRO&url='+encodeURIComponent(window.location.href)+'&text='+encodeURIComponent(this.model.attributes.title)+'"><img style="width:32px" src="/assets/imgs/social/icon_twitter_b.png" /></a>';
			
			$('.radioSocial').prepend(htm);
			
			
			/* 
				Special messaging while live (eg, call in phone number)	
			*/
			if(this.model.attributes.slug==="anotherview"){
				htm  = "";
				htm += "<p class='font-bold mb0 text-center'>Join the Show</p>"
				htm += "<div class='row mb4 text-center font-bold' style='color:#f67f1c'>"
				htm += 	"<span class='col lh1'>1-800-940-2240</span>";
				htm += 	"<span class='col lh1 border-l-lg'><a style='color:#f67f1c' href='mailto:contact@anotherviewradio.org'>contact@anotherviewradio.org</a></span>";
				htm += 	"<span class='col lh1 border-l-lg'>757-440-2665</span>";
				htm += "</div>"
	
				$('#msg_liveNow').html(htm);
			}
			
			/* 
	           Google Ads 
	         */
            Backbone.Radio.channel('ads').trigger('show','radio')
        }
    });
	    
	return new (episodeView)();
});



/************************************************************************************
	RADIO - Playlist
	(Called from show-live-radio-episode and show-radio-episode)
 ************************************************************************************/ 
Backbone.Radio.channel('views').reply('radio-playlist',function(data){
	var playlist = "";
	var isClassical = false;

	var wrappedPlaylist = "";
	
	try{
		var plJSON;
		if(Array.isArray(data)){ //live data
			plJSON = data;
		}else{
			plJSON = JSON.parse(data);
		}
		//at this point, we don't know what station this program is from.
		//	At best, we can get that it is part of stationId=2, but that doesn't mean much long term.
		//	So check to see if composer is in the dataset at least half the time. If so, take a guess that it's classical.
		if(plJSON.length){
			if((_.filter(plJSON,function(e){ return e.composer; }).length / plJSON.length ) > 0.5 ){
				isClassical = true;		
			}
		}
		
		wrappedPlaylist +='<div id="playlistContainer" class="playlist'+((isClassical)?' playlist_classical ':"")+' row font-light m0 mt4">';

		if(isClassical){
			wrappedPlaylist +='<div class="col-md-2 font-bold pl1 pr1">Time</div>';
			wrappedPlaylist +='<div class="col-md-3 font-bold pl1 pr1">Composer</div>';
			wrappedPlaylist +='<div class="col-md-4 font-bold pl1 pr1">Title</div>';
			wrappedPlaylist +='<div class="col-md-3 font-bold pl1 pr1">Artist</div>';
		}else{
			wrappedPlaylist +='<div class="col-md-2 font-bold pl1 pr1">Time</div>';
			wrappedPlaylist +='<div class="col-md-4 font-bold pl1 pr1">Song</div>';
			wrappedPlaylist +='<div class="col-md-3 font-bold pl1 pr1">Artist</div>';
			wrappedPlaylist +='<div class="col-md-3 font-bold pl1 pr1">Album</div>';
		}
		
        var prev = {
	         song:""
	        ,artist:""
        };
        _.each(plJSON, function(p){
	        /* We have cases, especially in Classical, where the same song will appear multiple times in a row,
		        either with or without a new timestamp. So attempt to dedupe when possible. */
	        if( (p.song === prev.song) && (p.artist === prev.artist)){ return; }
		    prev.song = p.song;
		    prev.artist = p.artist;
		        
	        if(isClassical){
		        playlist += "<div class='col-md-2 pl1 pr1'>"+((p.time)?p.time:"")+"</div>"
		    	//composer often ends with " -" for some reason, so strip that off if present
		    	playlist += "<div class='col-md-3 pl1 pr1'>"+((p.composer)?((p.composer.endsWith(' -'))?p.composer.slice(0,-2):p.composer):"")+"</div>"
		    	playlist += "<div class='col-md-4 pl1 pr1'>"+((p.song)?p.song:"")+"</div>"
		    	playlist += "<div class='col-md-3 pl1 pr1'>"+((p.artist)?p.artist:"")+"</div>"
		    }else{
			    playlist += "<div class='col-md-2 pl1 pr1'>"+((p.time)?p.time:"")+"</div>"
		    	playlist += "<div class='col-md-4 pl1 pr1'>"+((p.song)?p.song:"")+"</div>"
		    	playlist += "<div class='col-md-3 pl1 pr1'>"+((p.artist)?p.artist:"")+"</div>"
		    	playlist += "<div class='col-md-3 pl1 pr1'>"+((p.album)?p.album:"")+"</div>"
		    }
        })	
	}catch(e){
		//console.log('JSON.parse error',e)
	}
	
	playlist = (playlist)?wrappedPlaylist+playlist+"</div>":""
	return playlist;
});




/************************************************************************************
	RADIO - Segments
	(Called from show-radio-episode, at the moment, only for some NPR shows)
 ************************************************************************************/ 
Backbone.Radio.channel('views').reply('radio-segments',function(data){			
	var playlist = "";
	var wrappedPlaylist = "";
	wrappedPlaylist +='<div id="playlistContainer" class="segments row font-light m0 mt4">';
		wrappedPlaylist +='<div class="col-md-2 font-bold pl1 pr1">&nbsp;</div>';
		wrappedPlaylist +='<div class="col-md-5 font-bold pl1 pr1">Title</div>';
		wrappedPlaylist +='<div class="col-md-5 font-bold pl1 pr1">Description</div>';
		
	    _.each(data, function(a, index){
			    playlist += "<div class='rowDiv' data-index='"+index+"'>" 
		    	playlist += "<div class='col-md-2 pl1 pr1 pt1'><button class='btn btn-sm mr1 play' data-index='"+index+"'>Play</button></div>"
		    	playlist += "<div class='col-md-5 pl1 pr1'>"+((a.title)?a.title:"")+"</div>"
		    	playlist += "<div class='col-md-5 pl1 pr1'>"+((a.desc_long)?a.desc_long:"")+"</div>"
		    	playlist += "</div>" 
	    })	
	
	playlist = (playlist)?wrappedPlaylist+playlist+"</div>":""
		
	return playlist;
});



/***********************************************************************
	RADIO
 ***********************************************************************/ 
Backbone.Radio.channel('views').reply('show-radio',function(options){	
	function renderCustomArea_Top(that){
		//Custom Area - Top (Events)
		$.when( Backbone.Radio.channel('entities').request('show_attrs',{programId:that.model.id,type:'event'}) ).done(function(data){ 
			if(!data.length){ return; }
			var models;
			
			//split out fields using JSON
			// remove old events
			models = _.filter(data.models,function(ev){
				var content = {};
		        try{
			        content = JSON.parse(ev.attributes.content);

			        if(!content.date){ return false; } //no date, something is horribly wrong, so remove the event
			        if( moment().isAfter(content.date, 'day') ){ return false; } //event is in the past, so remove event
			        
			        ev.attributes.date = content.date;
			        ev.attributes.time = content.time;
			        ev.attributes.text = content.text;			        
			        return true;
		        }catch(e){
			        //failed json, so remove it from the list
			        return false;
		        }
			})
			
			//yeah, we had events, but we might not now that we excluded old ones
			if(!models.length){ return; }
			
			//sort by newest first
			models = _.sortBy(models, function(a){
				return moment(a.attributes.date).format('x');
			})
			
			//display
			var htm = "";
			htm += '<h2 class="font-normal m0 mt4">Upcoming Events</h2>';
			htm += '<div class="row">';
			_.each(models,function(ev){
				var date = (ev.attributes.date)?moment(ev.attributes.date).format('dddd, MMMM D'):"";
				
				htm += '<div class="col-md-6">';
				htm += '<p><span class="font-bold">';
				htm += date + ", " + ev.attributes.time
				htm += '</span><br>';
				htm += ev.attributes.text;
				htm += '</div>';
			})
			htm += '</div>';
			
			that.$el.find('#tmpl-show-radio-customAreaTop').prepend(htm)
		});
        
        
        if(that.model.attributes.slug==='writersblock'){
			var htm = "";
			htm += '<div class="row">';
			htm += '	<div class="col-md-12"><div class="py4 px8" style="background:#d9d9d6"><p class="m0">Artists are invited to submit their work for consideration. <a href="https://whro.submittable.com/submit/92979/writers-block">Submit your work.</a></p></div></div>';
			htm += '</div>';
            that.$el.find('#tmpl-show-radio-customAreaTop').append(htm)
        }
        
	}
	
	function renderCustomArea_Bottom(that){
		/*
			Upcoming Episodes
		 */
		$.when( Backbone.Radio.channel('entities').request('show_attrs',{programId:that.model.id,type:'upcomingepisode'}) ).done(function(data){ 
			if(!data.length){ return; }
			var models;
			
			//split out fields using JSON
			// remove old events
			models = _.filter(data.models,function(ev){
				var content = {};
		        try{
			        content = JSON.parse(ev.attributes.content);

			        if(!content.date){ return false; } //no date, something is horribly wrong, so remove
			        /* Because the two shows this is designed for both air at noon, we expire upcoming episodes at noon.
				        We will have to address this line is we start using it for shows in other time slots */
			        if( moment().isAfter(moment(content.date).hours(12).startOf('hour')) ){ return false; } //in the past, so remove
			        
			        ev.attributes.date = content.date;
			        ev.attributes.text = content.text;			        
			        return true;
		        }catch(e){
			        //failed json, so remove it from the list
			        return false;
		        }
			})
			
			//yeah, we had episodes, but we might not now that we excluded old ones
			if(!models.length){ return; }

			//sort by newest first
			models = _.sortBy(models, function(a){
				return moment(a.attributes.date).format('x');
			})
			
			//display
			var htm = "";
			htm += '<h2 class="font-normal m0 mt4 pt8 border-t">Join Us Next Time</h2>';
			_.each(models,function(ev){
				var date = (ev.attributes.date)?moment(ev.attributes.date).format('dddd, MMMM D'):"";
				var text = (ev.attributes.text.lastIndexOf("<p",0)===0)?ev.attributes.text : "<p>"+ev.attributes.text+"</p>";
				
				htm += '<div class="row mb8">';
				htm += '<div class="col">';
				htm += '<p class="font-size1">';
				htm += date 
				htm += '</p>';
				htm += '<h3 class="font-normal mt4 mb0">'+ev.attributes.name+'</h3>'
				htm += '<div class="mt4">'+text+'</div>';
				htm += '</div>';
				htm += '</div>';
			})
			
			that.$el.find('#tmpl-show-radio-customAreaBottom').append(htm)
		});
		
		
		/*
			Custom: bottom of the page content
			- built for AV's eNews signup, but put whatever	
		*/
		if(that.model.attributes.slug==='anotherview'){
			htm  = "";
			htm += "<div class='py8 px8' style='background:#d9d9d6'>";
			htm += "<p>If you like our programming, consider subscribing to our weekly email updates. By signing up, you acknowledge that your email will be used to send you our enewsletter. You can unsubscribe at any time using the link in our emails, and we <a target='_blank' href='https://www.whro.org/privacy-policy'>respect your privacy</a>.</p>"
			htm += "<p style='margin-bottom:0px;'><a style='background-color:#53565A; color:#F2CD00; padding:10px; text-decoration:none;' target='blank' href='https://www.whro.org/subscribe-to-the-another-view-enewsletter#/'>SUBSCRIBE HERE</a></p>"
			htm += "</div>";
			that.$el.find('#tmpl-show-radio-customAreaBottom').prepend(htm);
		}
	}
	
	function renderPersonalities(that){
		
		$.when( Backbone.Radio.channel('entities').request('persons',{programId:that.model.attributes.id}) ).done(function(data){ 
        	if(data.length){
	        	var htm = "";
	        	htm += "<h3 class='mt4'>Creators / Contributors:</h3>"
	        	htm += '<div class="row">';
	        	_.each(data.models,function(p){
		        	var imgs = JSON.parse(p.attributes.images);
					imgs = _.find(imgs,function(i){ return i.profile === "portrait"; })
					
					htm += '<div class="col-md-6">';
					htm += (imgs && imgs.image)?'<img alt="" src="'+imgs.image+'" />':'';
					htm += '<a href="/person/'+p.attributes.slug+'">'+p.attributes.name+'</a>';
					htm += '</div>';
				})
	        	htm += '</div>';
	        	that.$el.find('#tmpl-show-radio-Personalities').html(htm)
	        }
		});
	}
	
	var radioPageView = Mn.View.extend({
		
	        /* Add in stuff from options that normally gets auto-applied */
	         model:options.model
	        ,className:"page_program_radio py8"
	        ,template:"#tmpl-show-radio"
	        ,templateContext:function(){
		        var imgs = JSON.parse(this.model.attributes.images);
		        imgs = _.find(imgs,function(i){ return i.profile === "show-banner"; })
		        
		        /* Our radio programs tend to have "with so-and-so" at the end of the title,
			        which is looks wrong and takes up too much space. So when you find that,
			        wrap the 'with' section in a small tag and make the font lighter to give some contrast. */
		        var title = this.model.attributes.title;
		        if(title.indexOf(" with ")!==-1){
			        var tmp = title;
			        title = tmp.slice(0,title.indexOf(" with "))+"<small class='font-light'>"+tmp.slice(title.indexOf(" with "),tmp.length)+"</small>"
		        }
		        return {
			    	 img			: (imgs && imgs.image)?imgs.image:""
			    	,title			: title
			    	,specificEpisode: (options.attributes && options.attributes.episode)?true:false
			    	,isLive			: (this.model.attributes && this.model.attributes.isLive)?true:false
			    	,isEpiAvailable	: options.isEpiAvailable
			    	,is_epi_page	: options.is_epi_page// checks if it is main page or episode page 
		    	}
		     }
	        ,regions:{
	            episodeContainer:{
	                el: '.episodeContainer'
	            }
	        }
	        ,onRender: function() {
		        var that = this;	        
		        /* Set <body> class. Gets removed in onDomRemove() */
	        $('body').addClass("page_program_"+this.model.attributes.slug)
		        
		        /* Specific Episode Requested */
		        if(options.attributes && options.attributes.episode){
			        this.showChildView('episodeContainer', Backbone.Radio.channel('views').request('show-radio-episode',{
				         model:options.attributes.episode
				        ,attributes:{
	                        program:that.model.attributes
	                         ,isLocal : options.model.isLocal
                        }
				    }));
		        }else if(options.model.attributes.isLive){ //waiting for is_live to exist
			        //this is live on air now, so show the station player and get the live playlist
	                this.showChildView('episodeContainer', Backbone.Radio.channel('views').request('show-live-radio-episode',{
				         model:options.model
				        ,attributes:{
	                         isLocal : options.model.isLocal
                        }
				    }));
	                
	            }else{
	                // Didn't request a specific episode, and this program isn't live on air, so get the latest
			        // Get list of episodes so we can grab the newest one
	                $.when( Backbone.Radio.channel('entities').request('episodes',{showId:this.model.id,limit:1,sort:'airdate'}) ).done(function(data){ 
	                    that.showChildView('episodeContainer', Backbone.Radio.channel('views').request('show-radio-episode',{
							 collection: data
	                        ,attributes:{
		                        program:that.model.attributes
		                        ,isLocal : options.model.isLocal
	                        }
		        		}));  
	                })  
                }

                
                renderCustomArea_Top(this);
				renderCustomArea_Bottom(this);
				renderPersonalities(this);
				
	        }
	        ,onDomRemove:function(){
				//we almost exclusively use actual links, not events to go to new pages to prevent player issues,
				//	making this not needed. But just in case, leave it in to remove the program class
		        $('body').removeClass("page_program_"+this.model.attributes.slug)
				videojs('player').dispose();
	        }
	        ,events:{
                "click #playlistContainer button[data-index=0].play": function(e){	
	                $(e.currentTarget).removeClass('play').addClass('stop').html("Stop");
	                Backbone.Radio.channel('media').request('play:firstPlaylistItem',$(e.currentTarget).attr('data-index'))
	            },
				"click #playlistContainer button.play": function(e){
					if ($(e.currentTarget).attr('data-index') !== "0") {	
						$(e.currentTarget).removeClass('play').addClass('stop').html("Stop");
						Backbone.Radio.channel('media').request('play:playlistItem',$(e.currentTarget).attr('data-index'))
					}
	            },  
	            "click #playlistContainer button.stop": function(e){            
		            $(e.currentTarget).html("Paused").removeClass('stop play').addClass('paused');
		            Backbone.Radio.channel('media').request('pause:playlistItem',$(e.currentTarget).attr('data-index'))
	            },
	            "click #playlistContainer button.paused": function(e){
		            $(e.currentTarget).html("Stop").removeClass('paused play').addClass('stop');
	                Backbone.Radio.channel('media').request('resume:playlistItem',$(e.currentTarget).attr('data-index'))
	            }
	        }
	    })
	    
	return new (radioPageView)();
});